<template>
  <div class="login">
    <Logos />
    <HseSpace size='small' vertical />
    <div v-if="lang === 'ru'">
      <span class="hse-RichInput__label">For English version please change the language</span>
    </div>
     <HseSpace size='small' vertical />
    
    <HseButton v-on:click="() => setState('login')">{{ $t('auth.login') }}</HseButton>
    <HseSpace size='small_2x' vertical />
    <HseButton v-on:click="adfs">{{ $t('auth.adfs') }}</HseButton>
    <HseSpace size='small_2x' vertical />
    <HseButton v-on:click="() => setState('code')">{{ $t('auth.code') }}</HseButton>
    <HseSpace size='small_2x' vertical />
    <div class="links">
      <span class="link" v-on:click="() => setState('loginOptions')">{{ $t('back') }}</span>
    </div>
  </div>
</template>

<script>
import { HseButton, HseSpace } from '@hse-design/vue'
import { mapState } from 'vuex'
import { api } from '../../../api'
import Logos from './Logos.vue'

export default {
  name: 'LoginOptions',
  props: ['state'],
  components: {
    HseButton,
    HseSpace,
    Logos
  },
  beforeCreate() {
    api.loginByKeyCloak()
  },
  methods: {
    adfs() {
      window.location.replace(`${window.location.origin}/auth/keycloak/login?lang=${this.lang}`)
    },
    setState(state) {
      this.$emit('changeState', { state })
    },
  },
  computed: {
    isLangRu() {
      return this.lang === 'ru'
    },
    isLang() {
      return this.$store.state.lang === 'ru'
    },
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      console.log(this.lang)
    },
  },
}
</script>

<style scoped>
.login {
  width: 340px;
  background: #FFFFFF;
  border-radius: 12px;
  margin: 53px auto;
  padding: 24px 30px;
}

.links {
  text-align: center;
}

.link {
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  text-decoration-line: underline;
  color: #0060CF;
  clear: both;

}

.register_link {
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;
  border-bottom: #0060CF 1px solid;

  font-weight: 600;
  display: inline-block;
  color: #0060CF;
  clear: both;
}

.register {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.hse-Button {
  width: 100% !important;
}

.tooltip {
  width: 400px;
}

@media (max-width: 767px) {
  .login {
    margin: 16px auto;
  }
}

@media (max-width: 374px) {
  .login {
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
  }
}
</style>
